import SEO from "@/components/SEO";
import { PageHero, LegalDoc } from "@/components/Bits";
import { MARKETPLACE } from "@/content/policies";

export default function MarketplacePolicy() {
  return (
    <div data-testid="marketplace-policy-page">
      <SEO
        title="Marketplace & Product Listing Policy"
        description="How product listings work on Middle Man — independent sellers, listing review, compliance documents, prohibited products, address privacy and direct payments."
        path="/marketplace-policy"
      />
      <PageHero
        kicker="Policies"
        title="Marketplace & Product Listing Policy"
        subtitle="Effective from: 11 September 2026 · How products are listed, reviewed, ordered and delivered on Middle Man."
      />
      <LegalDoc doc={MARKETPLACE} />
    </div>
  );
}
